"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShoppingBag, Plus } from "lucide-react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { motion } from "framer-motion";

interface Watch {
    _id: string;
    name: string;
    image: string;
    price: number;
    brand: string;
    model: string;
    // Add other watch properties as needed
}

interface CartAddedModalProps {
    isOpen: boolean;
    onClose: () => void;
    watch: Watch;
}

export function CartAddedModal({ isOpen, onClose, watch }: CartAddedModalProps) {
    const router = useRouter();

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md bg-slate-900 border border-slate-800 shadow-xl">
                <div className="flex flex-col items-center space-y-4 p-6">
                    <motion.div
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        className="w-32 h-32 relative rounded-lg overflow-hidden ring-2 ring-blue-500/50"
                    >
                        <Image
                            src={watch.image}
                            alt={watch.name}
                            fill
                            className="object-cover"
                        />
                    </motion.div>

                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className="text-center space-y-2"
                    >
                        <h3 className="text-xl font-semibold text-slate-200">Added to Cart!</h3>
                        <p className="text-slate-400">{watch.name}</p>
                    </motion.div>

                    <div className="flex flex-col w-full space-y-2 mt-4">
                        <Button
                            onClick={() => router.push('/checkout')}
                            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600"
                        >
                            <ShoppingBag className="mr-2 h-4 w-4" />
                            Proceed to Checkout
                        </Button>

                        <Button
                            variant="outline"
                            onClick={() => router.push('/marketplace')}
                            className="w-full border-slate-700 hover:bg-slate-800"
                        >
                            <Plus className="mr-2 h-4 w-4" />
                            Add More Items
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}